<app-dialog-header
	[title]="'confirmDialog.dialog.title'"
	(closeClick)="close()"
></app-dialog-header>
<div>
	<mat-dialog-content class="center-block">
		<h4>{{ "confirmDialog.dialog.message" | translate }}</h4>
		<br />

		<div class="d-flex text-center justify-content-center gap-3">
			<a
				(click)="close()"
				class="btn btn-outline"
			>
				<i
					class="fa fa-times"
					style="padding-right: 8px"
				>
				</i>
				{{ "confirmDialog.dialog.cancel" | translate }}
			</a>
			<a
				(click)="ok()"
				class="btn btn-blue"
			>
				<i
					class="fa fa-check-circle"
					style="padding-right: 8px"
				></i>
				{{ "confirmDialog.dialog.ok" | translate }}
			</a>
		</div>
	</mat-dialog-content>
</div>
